import React from 'react'
import PropTypes from 'prop-types'
import { isUndefined } from 'lodash-es'
import classnames from 'classnames'
import './style.scss'

class Toggle extends React.Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  handleClick() {
    const { disabled, toggled, onChange } = this.props

    if (disabled) {
      return false
    }

    onChange(!toggled)
    return true
  }

  handleKeyDown(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.handleClick()
    }
  }

  render() {
    const { toggled, disabled, ariaLabel } = this.props
    const classes = classnames('toggle', {
      'toggle-on': !isUndefined(toggled) && toggled,
      'toggle-off': !isUndefined(toggled) && !toggled,
      disabled,
    })
    const tabIndex = disabled ? -1 : 0

    return (
      <div
        role="switch"
        tabIndex={tabIndex}
        aria-checked={!isUndefined(toggled) && toggled}
        aria-label={ariaLabel || ''}
        className={classes}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
      >
        <div className="toggle-handle" />
      </div>
    )
  }
}

Toggle.propTypes = {
  toggled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
}

export default Toggle
